import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { ShareSessionBody } from "~/pages/manifold-nextgen/components/conversations/share/ShareSessionBody";
import { useConversationShare } from "~/pages/manifold-nextgen/components/conversations/share/useConversationShare";

interface ShareConversationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  conversationId: string;
}

export const ShareConversationDialog = ({
  open,
  onOpenChange,
  conversationId,
}: ShareConversationDialogProps) => {
  const share = useConversationShare(conversationId, open);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Share Session</DialogTitle>
          <DialogDescription>Anyone with the link can view, read-only.</DialogDescription>
        </DialogHeader>

        <ShareSessionBody share={share} />
      </DialogContent>
    </Dialog>
  );
};
